export const STEPS_LIST = [
  {
    name: 'Account',
  },
  {
    name: 'Liability',
  },
  {
    name: 'Asset tags',
  },
  {
    name: 'Summary',
  },
]

export const TRANSACTION_TYPE = 'add liability'
export const ASSET_TYPE = 'loan'

export const ASSET_CLASSES_LIST = ['Borrowings']

export const INVESTMENT_STRATEGIES_LIST = ['Mortgage', 'Line Of Credit']
